import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-coming-soon-dialog',
  templateUrl: './coming-soon-dialog.component.html',
  styleUrls: ['./coming-soon-dialog.component.scss']
})
export class ComingSoonDialogComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<ComingSoonDialogComponent>
  ) { }

  ngOnInit(): void { }

  closeDialog(): void {
    this.dialogRef.close();
  }
}
